import App from 'app/app.js';

function LtProcessingDialogDirective() {
  return {
    restrict: 'E',
    template:
      '<div class="row">' +
      '    <div class="col-md-12">' +
      '        <img src="assets/images/lifetouch_spinner.gif" alt="Lifetouch Spinner" width="100" height="100" style="margin: 40px 0;">' +
      '     </div>' +
      '</div>' +
      '<span lt-translate="PROCESSING_PAYMENT_MESSAGE"></span>'
  };
}

App.directive('ltProcessingDialog', [LtProcessingDialogDirective]);
